export const auxInfoEnum = {
    firstTimer: "first-timer",
    helpCharCreate: "help-char-create",
    discordHandle: "discord-handle",
    veils: "veils",
    lines: "lines"
};

export const timezones: { value: number, label: string }[] = [
    { value: -720, label: "GMT -12:00"},
    { value: -660, label: "GMT -11:00 (SST)"},
    { value: -600, label: "GMT -10:00 (HST)"},
    { value: -570, label: "GMT -09:30"},
    { value: -540, label: "GMT -09:00 (AKST, HDT)"},
    { value: -480, label: "GMT -08:00 (PST, AKDT)"},
    { value: -420, label: "GMT -07:00 (MST, PDT)"},
    { value: -360, label: "GMT -06:00 (CST, MDT)"},
    { value: -300, label: "GMT -05:00 (EST, CDT)"},
    { value: -270, label: "GMT -04:30 "},
    { value: -240, label: "GMT -04:00 (AST)"},
    { value: -210, label: "GMT -03:30 (NST)"},
    { value: -180, label: "GMT -03:00"},
    { value: -120, label: "GMT -02:00"},
    { value: -60, label: "GMT -01:00"},
    { value: 0, label: "GMT +00:00 (UTC, WET)"},
    { value: 60, label: "GMT +01:00 (CET, WAT)"},
    { value: 120, label: "GMT +02:00 (CAT, EET)"},
    { value: 180, label: "GMT +03:00 (EAT, MSK)"},
    { value: 240, label: "GMT +04:00"},
    { value: 270, label: "GMT +04:30"},
    { value: 300, label: "GMT +05:00"},
    { value: 330, label: "GMT +05:30 (IST)"},
    { value: 360, label: "GMT +06:00"},
    { value: 390, label: "GMT +06:30"},
    { value: 420, label: "GMT +07:00 (WIB)"},
    { value: 480, label: "GMT +08:00 (WITA, CST, PST)"},
    { value: 510, label: "GMT +08:30"},
    { value: 540, label: "GMT +09:00 (WIT, KST, JST)"},
    { value: 570, label: "GMT +09:30 (ACST)"},
    { value: 600, label: "GMT +10:00 (ChST, AEST)"},
    { value: 660, label: "GMT +11:00 (AEDT)"},
    { value: 720, label: "GMT +12:00 (NZST)"},
]